













































import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";
import {computed, defineComponent, PropType, ref, watch} from "@vue/composition-api";
import {BuilderSection} from "@tool/Builder/Builder.types";

export default defineComponent({
    components: {
        ThemeBlock,
    },
    props: {
        currentSection: {
            type: String as PropType<BuilderSection>,
            required: true
        }
    },
    setup(props) {

        const marginTop = ref('0px');

        const style = computed(() => {
            return {
                'margin-top': marginTop.value
            }
        });

        const shouldDisplay = computed(() => {
            return window.innerWidth > 991;
        });

        watch(() => props.currentSection, (new2, old2) => {

            if (!shouldDisplay) {
                return;
            }

            const sectionId = `builder-section-${props.currentSection}`;

            let sectionElement = document.getElementById(sectionId);

            if (!sectionElement) {
                throw new Error('Wrong section');
            }

            let targetOffset = sectionElement.offsetTop;

            marginTop.value = targetOffset + 'px';

        });


        return {shouldDisplay, style}
    }
});
